<template>
    <Modal v-model="isShow"

           :mask-closable="false"  :loading="loading" width="930"
           @on-ok="ok" @on-cancel="cancel"
           :class-name="preModal"
           class="mask"
           :ok-text="src?'确认解约并提交审核':'确定'"

    >
      <h3 slot="header" class="modal-header">解约协议预览</h3>
      <div style="height: 700px">
        <iframe :src="src" class="iframe" v-if="src"></iframe>
        <div v-else style="text-align: center;line-height: 700px">
          {{srcLoading?'加载解约协议中...':'加载失败请重试'}}

        </div>
      </div>
    </Modal>
</template>
<script>
import {contractText} from "../../../../api/contractList";

export default {
    name: ""   ,
    components:{
    },
    props:{
      n: {
        type: Number,
        default: 0
      },
      contractFid:{
        type:String,
        default: ''

      }
      // src:{
      //   type:String,
      //   default:''
      // }

    },
    watch:{
      n(){
        this.src=''
        this.$nextTick(()=>{
        this.contractText()
        this.isShow=true

        })

      }
    },
    data(){
      return {
        srcLoading:false,
        preModal:'preModal',
        loading: true,
        isShow:false,
        src:'',
      }
    },
    methods:{
      contractText(){
        if(!this.contractFid){
          return
        }
        let params={
          contractFid:this.contractFid
        }
        this.srcLoading=true
        contractText(params).then(res=>{
          if(!res.data){
            return
          }
          if(location.host==="zyu.ziroom.com" && res.data.noSignContractUrl.indexOf('https')===-1){
            res.data.noSignContractUrl=  res.data.noSignContractUrl.replace('http','https')
          }
          this.src=res.data.noSignContractUrl

        }).catch(error=>{}).finally(()=>{
          this.srcLoading=false
        })
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok(){

        // if(!this.src){
        //   this.isShow=false
        //   this.changeLoading()
        //   return
        // }

        setTimeout(()=>{
          this.$emit('ok')
          this.isShow=false
        },1000)


      },
      cancel(){

      }
    }

  }
</script>

<style scoped>
  .iframe{
    position: relative;
    width: 100%;
    height: 700px;
  }

</style>
